import { Typography } from "@material-ui/core";

import React from "react";

import { ProfileIcon } from "../../assets";

import useStyles from "./styles";
import { Button } from "../Button";

export interface CardPlan {
  name: string;
  photo: string;
  selectPlan: () => void;
}

export const CardPlan: React.FC<CardPlan> = ({
  name,
  photo,
  selectPlan,
}) => {
  const Styles = useStyles({ photo });

  return (
    <div className={Styles.card}>
      <div className={Styles.planInfos}>
        <div className={Styles.planTop}>
          <div className={Styles.planOwner}>
            <div className={Styles.ownerPhoto}>
              {photo ? (
                <div className={Styles.picture} />
              ) : (
                <ProfileIcon className={Styles.profileIcon} />
              )}
            </div>
            <div className={Styles.collunName}>
              <Typography component="span" className={Styles.ownerName} noWrap>
                {name}
              </Typography>
            </div>
          </div>

          <div className={Styles.planActions}>
            <Button color="primary" size="large" onClick={selectPlan}>
              Usuários
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
